import initMap from './request-sctipts/map';
import { loadMoreHandler } from './request-sctipts/main-request';
import tabsSliderInit from './components/tabs-slider';
import videoModalinit from './components/video-modal';
import modalDownload from './components/download-modal-form';
import webinarModal from './components/webinar-modal';
import {
	titleSizeChecker,
	titleFullSizeChecker,
} from './components/video-titles-size';

const commonScripts = () => {
	initMap();

	loadMoreHandler();
	tabsSliderInit();
	videoModalinit();
	modalDownload();
	webinarModal();
	titleSizeChecker();
	titleFullSizeChecker();

	window.addEventListener('resize', function (event) {
		tabsSliderInit();
	});
};

export default commonScripts;
